import {Cloudinary} from "@cloudinary/url-gen";

const cld = new Cloudinary({
  cloud: {
    cloudName: 'drhjmycvo'
  }
});

export default cld; 